import { render, staticRenderFns } from "./FieldCheckbox.vue?vue&type=template&id=3edbf7ca"
import script from "./FieldCheckbox.vue?vue&type=script&lang=js"
export * from "./FieldCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FieldCheckbox.vue?vue&type=style&index=0&id=3edbf7ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports